const RAZORPAY_SCRIPT_URL = 'https://checkout.razorpay.com/v1/checkout.js';

let scriptPromise = null;

export function loadRazorpayScript() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Razorpay is only available in the browser'));
  }
  if (window.Razorpay) {
    return Promise.resolve(window.Razorpay);
  }
  if (scriptPromise) {
    return scriptPromise;
  }

  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${RAZORPAY_SCRIPT_URL}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve(window.Razorpay));
      existing.addEventListener('error', () => reject(new Error('Failed to load Razorpay')));
      return;
    }

    const script = document.createElement('script');
    script.src = RAZORPAY_SCRIPT_URL;
    script.async = true;
    script.onload = () => resolve(window.Razorpay);
    script.onerror = () => reject(new Error('Failed to load Razorpay'));
    document.body.appendChild(script);
  });

  return scriptPromise;
}

/**
 * Open Razorpay checkout modal.
 * @param {object} checkout - API response from POST subscription/checkout
 * @param {object} options - { name, email, phone, onSuccess, onDismiss }
 */
export async function openRazorpayCheckout(checkout, options = {}) {
  const Razorpay = await loadRazorpayScript();

  return new Promise((resolve, reject) => {
    const rzp = new Razorpay({
      key: checkout.key_id,
      amount: checkout.amount,
      currency: checkout.currency || 'INR',
      name: checkout.school_name || 'School Analytics',
      description: checkout.description || checkout.plan_name || 'Subscription',
      order_id: checkout.order_id,
      prefill: {
        name: options.name || '',
        email: options.email || '',
        contact: options.phone || '',
      },
      theme: { color: '#2563eb' },
      handler(response) {
        const payload = {
          payment_id: checkout.payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
        };
        if (typeof options.onSuccess === 'function') {
          Promise.resolve(options.onSuccess(payload))
            .then(resolve)
            .catch(reject);
        } else {
          resolve(payload);
        }
      },
      modal: {
        ondismiss() {
          if (typeof options.onDismiss === 'function') {
            options.onDismiss();
          }
          reject(new Error('Payment cancelled'));
        },
      },
    });

    rzp.on('payment.failed', (response) => {
      const msg = response?.error?.description || 'Payment failed';
      reject(new Error(msg));
    });

    rzp.open();
  });
}
